import {
  BarChart3,
  Calendar,
  CreditCard,
  Home,
  Settings,
  ArrowDownCircle,
  ArrowUpCircle,
  ArrowLeftRight,
  TrendingUp,
  AlertTriangle,
  FileText,
  FolderPlus,
  Building2,
  Tag,
  Wallet,
  Users,
  Truck,
  User,
  Bell,
  Shield,
  UserMinus,
  FolderKanban,
  Briefcase,
  DollarSign,
  TrendingDown,
  HardHat,
  Receipt,
  Ruler,
  Scale,
  Stethoscope,
  PartyPopper,
  Laptop,
  Camera,
  GraduationCap,
  Activity,
  PawPrint,
  Sparkles,
  Wrench,
  Scissors,
  Package,
  ShoppingCart,
  ClipboardList,
  Car,
  Box,
  Handshake,
  Search,
  Mail,
  RefreshCw,
  Layers,
} from "lucide-react";
import { CompanyType } from "@/types/company";

export interface NavigationItem {
  title: string;
  icon: any;
  path?: string;
  subItems?: NavigationItem[];
}

const baseNavigationItems: NavigationItem[] = [
  {
    title: "Início",
    icon: Home,
    // Sem path nem subItems - será usado como trigger para mostrar todos os menus principais
  },
  {
    title: "Dashboard",
    icon: Home,
    path: "/dashboard",
  },
  {
    title: "Todas as Transações",
    icon: CreditCard,
    path: "/transactions",
  },
  {
    title: "Transações Recorrentes",
    icon: RefreshCw,
    path: "/recurring",
  },
  {
    title: "Transações Parceladas",
    icon: Layers,
    path: "/installments",
  },
  {
    title: "Contas a Pagar",
    icon: ArrowDownCircle,
    path: "/transactions/expenses",
  },
  {
    title: "Contas a Receber",
    icon: ArrowUpCircle,
    path: "/transactions/incomes",
  },
  {
    title: "Calendário",
    icon: Calendar,
    path: "/calendar",
  },
  {
    title: "Fluxo de Caixa",
    icon: TrendingUp,
    path: "/cash-flow",
  },
  {
    title: "Inadimplentes",
    icon: AlertTriangle,
    path: "/overdue",
  },
  {
    title: "Competência",
    icon: FileText,
    path: "/accrual",
  },
  {
    title: "Relatórios",
    icon: BarChart3,
    subItems: [
      {
        title: "Relatórios de Categorias",
        icon: BarChart3,
        path: "/reports/categories",
      },
      {
        title: "Centros de Custo",
        icon: Building2,
        path: "/reports/cost-centers",
      },
      {
        title: "Contas a Pagar",
        icon: CreditCard,
        path: "/reports/payables",
      },
      {
        title: "Contas a Receber",
        icon: ArrowUpCircle,
        path: "/reports/receivables",
      },
      {
        title: "Fluxo de Caixa",
        icon: TrendingUp,
        path: "/reports/cash-flow",
      },
    ],
  },
  {
    title: "Serviços",
    icon: Handshake,
    subItems: [
      {
        title: "Orçamentos",
        icon: FileText,
        subItems: [
          {
            title: "Listagem",
            icon: FileText,
            path: "/services/budgets",
          },
          {
            title: "Novo Orçamento",
            icon: FileText,
            path: "/services/budgets/new",
          },
          {
            title: "Análises",
            icon: BarChart3,
            path: "/services/budgets/analytics",
          },
          {
            title: "Relatórios",
            icon: TrendingUp,
            path: "/services/budgets/reports",
          },
          {
            title: "Taxas de Conversão",
            icon: TrendingUp,
            path: "/services/budgets/conversion",
          }
        ],
      },
      {
        title: "Vendas de serviços",
        icon: ShoppingCart,
        path: "/services/sales",
      },
      {
        title: "Contratos",
        icon: FileText,
        path: "/services/contracts",
      },
      {
        title: "Ordens de serviço",
        icon: ClipboardList,
        path: "/services/work-orders",
      },
      {
        title: "Parcelas a receber",
        icon: ArrowUpCircle,
        path: "/services/installments",
      },
      {
        title: "Notas fiscais de serviço",
        icon: Receipt,
        path: "/services/invoices",
      },
      {
        title: "Consulta Serasa",
        icon: Search,
        path: "/services/serasa",
      },
      {
        title: "Lembretes de vencimento",
        icon: Bell,
        path: "/services/due-reminders",
      },
      {
        title: "CONFIGURAÇÕES",
        icon: Settings,
        subItems: [
          {
            title: "Configurar notas fiscais",
            icon: Receipt,
            path: "/services/settings/invoices",
          },
          {
            title: "Modelo de e-mail de venda",
            icon: Mail,
            path: "/services/settings/email-template",
          },
          {
            title: "Séries de notas fiscais",
            icon: FileText,
            path: "/services/settings/invoice-series",
          },
        ],
      },
    ],
  },
  {
    title: "Conciliação Bancária",
    icon: ArrowLeftRight,
    path: "/reconciliation",
  },
  {
    title: "Cadastros",
    icon: FolderPlus,
    subItems: [
      {
        title: "Clientes",
        icon: Users,
        path: "/cadastros/clients",
      },
      {
        title: "Fornecedores",
        icon: Truck,
        path: "/cadastros/suppliers",
      },
      {
        title: "Centros de Custo",
        icon: Building2,
        path: "/cadastros/cost-centers",
      },
      {
        title: "Categorias",
        icon: Tag,
        path: "/cadastros/categories",
      },
      {
        title: "Contas de Pagamento",
        icon: Wallet,
        path: "/cadastros/payment-accounts",
      },
    ],
  },
  {
    title: "Configurações",
    icon: Settings,
    subItems: [
      {
        title: "Perfil",
        icon: User,
        path: "/settings",
      },
      {
        title: "Empresa",
        icon: Building2,
        path: "/settings/empresa",
      },
      {
        title: "Notificações",
        icon: Bell,
        path: "/settings/notifications",
      },
      {
        title: "Segurança",
        icon: Shield,
        path: "/settings/security",
      },
      {
        title: "Usuários da Empresa",
        icon: Users,
        path: "/settings/users",
      },
      {
        title: "Excluir Conta",
        icon: UserMinus,
        path: "/settings/delete-account",
      },
    ],
  },
];

/**
 * Get navigation items with conditional menu based on company type
 * @param companyType - The company type from the companies table
 * @returns Array of navigation items
 */
export function getNavigationItems(companyType: CompanyType | null | undefined): NavigationItem[] {
  const items = [...baseNavigationItems];

  // If company type is agencies, inject "Gestão de Projetos" menu after Dashboard
  if (companyType === CompanyType.AGENCIES) {
    const projectManagementMenu: NavigationItem = {
      title: "🚀 Gestão de Projetos",
      icon: FolderKanban,
      subItems: [
        {
          title: "Dashboard de Projetos",
          icon: BarChart3,
          path: "/projects/dashboard",
        },
        {
          title: "Todos os Projetos",
          icon: Briefcase,
          path: "/projects/list",
        },
        {
          title: "Lançar Custo em Projeto",
          icon: TrendingDown,
          path: "/projects/add-expense",
        },
        {
          title: "Contratos (Recorrência)",
          icon: FileText,
          path: "/projects/contracts",
        },
        {
          title: "Relatório de Lucratividade",
          icon: DollarSign,
          path: "/projects/profitability",
        },
      ],
    };

    // Insert after Dashboard (index 1)
    items.splice(1, 0, projectManagementMenu);
  }

  // If company type is construction, inject "Controle de Obras" menu after Dashboard
  if (companyType === CompanyType.CONSTRUCTION) {
    const constructionMenu: NavigationItem = {
      title: "🚧 Controle de Obras",
      icon: HardHat,
      subItems: [
        {
          title: "Dashboard de Obras",
          icon: BarChart3,
          path: "/construction/dashboard",
        },
        {
          title: "Todas as Obras",
          icon: Briefcase,
          path: "/construction/works",
        },
        {
          title: "Lançar Custo na Obra",
          icon: TrendingDown,
          path: "/construction/add-expense",
        },
        {
          title: "Medições (Recebimentos)",
          icon: Receipt,
          path: "/construction/measurements",
        },
        {
          title: "Relatório (Orçado vs. Realizado)",
          icon: DollarSign,
          path: "/construction/budget-vs-actual",
        },
      ],
    };

    // Insert after Dashboard (index 1)
    items.splice(1, 0, constructionMenu);
  }

  // If company type is architects/engineers, inject "Gestão de Projetos" menu after Dashboard
  if (companyType === CompanyType.ARCHITECTS_ENGINEERS) {
    const architectsMenu: NavigationItem = {
      title: "🏗️ Gestão de Projetos",
      icon: Ruler,
      subItems: [
        {
          title: "Dashboard de Projetos",
          icon: BarChart3,
          path: "/architects-engineers/dashboard",
        },
        {
          title: "Todos os Projetos",
          icon: Briefcase,
          path: "/architects-engineers/projects",
        },
        {
          title: "Lançar Custo no Projeto",
          icon: TrendingDown,
          path: "/architects-engineers/add-expense",
        },
        {
          title: "Etapas e Cronograma",
          icon: ClipboardList,
          path: "/architects-engineers/stages",
        },
        {
          title: "Relatório de Viabilidade",
          icon: DollarSign,
          path: "/architects-engineers/feasibility",
        },
      ],
    };

    // Insert after Dashboard (index 1)
    items.splice(1, 0, architectsMenu);
  }

  // If company type is consulting B2B, inject "Gestão de Consultoria" menu after Dashboard
  if (companyType === CompanyType.CONSULTING_B2B) {
    const consultingMenu: NavigationItem = {
      title: "💼 Gestão de Consultoria",
      icon: Briefcase,
      subItems: [
        {
          title: "Dashboard de Consultorias",
          icon: BarChart3,
          path: "/consulting/dashboard",
        },
        {
          title: "Todos os Projetos",
          icon: FolderKanban,
          path: "/consulting/projects",
        },
        {
          title: "Lançar Custo no Projeto",
          icon: TrendingDown,
          path: "/consulting/add-expense",
        },
        {
          title: "Contratos e Recorrências",
          icon: FileText,
          path: "/consulting/contracts",
        },
        {
          title: "Relatório de Rentabilidade",
          icon: DollarSign,
          path: "/consulting/profitability",
        },
      ],
    };

    // Insert after Dashboard (index 1)
    items.splice(1, 0, consultingMenu);
  }

  // If company type is health clinics, inject "Gestão Clínica" menu after Dashboard
  if (companyType === CompanyType.HEALTH_CLINICS) {
    const healthClinicsMenu: NavigationItem = {
      title: "🏥 Gestão Clínica",
      icon: Stethoscope,
      subItems: [
        {
          title: "Dashboard Clínico",
          icon: BarChart3,
          path: "/health-clinics/dashboard",
        },
        {
          title: "Pacientes",
          icon: Users,
          path: "/cadastros/clients",
        },
        {
          title: "Agendamentos",
          icon: Calendar,
          path: "/calendar",
        },
        {
          title: "Procedimentos",
          icon: ClipboardList,
          path: "/health-clinics/procedures",
        },
        {
          title: "Relatório de Receitas",
          icon: DollarSign,
          path: "/health-clinics/revenue",
        },
      ],
    };

    // Insert after Dashboard (index 1)
    items.splice(1, 0, healthClinicsMenu);
  }

  // If company type is law firms, inject "Gestão Jurídica" menu after Dashboard
  if (companyType === CompanyType.LAW_FIRMS) {
    const lawFirmsMenu: NavigationItem = {
      title: "⚖️ Gestão Jurídica",
      icon: Scale,
      subItems: [
        {
          title: "Dashboard Jurídico",
          icon: BarChart3,
          path: "/law-firms/dashboard",
        },
        {
          title: "Processos",
          icon: FileText,
          path: "/law-firms/cases",
        },
        {
          title: "Clientes",
          icon: Users,
          path: "/cadastros/clients",
        },
        {
          title: "Honorários",
          icon: DollarSign,
          path: "/law-firms/fees",
        },
        {
          title: "Relatório de Performance",
          icon: TrendingUp,
          path: "/law-firms/performance",
        },
      ],
    };

    // Insert after Dashboard (index 1)
    items.splice(1, 0, lawFirmsMenu);
  }

  // If company type is event producers, inject "Gestão de Eventos" menu after Dashboard
  if (companyType === CompanyType.EVENT_PRODUCERS) {
    const eventProducersMenu: NavigationItem = {
      title: "🎉 Gestão de Eventos",
      icon: PartyPopper,
      subItems: [
        {
          title: "Dashboard de Eventos",
          icon: BarChart3,
          path: "/events/dashboard",
        },
        {
          title: "Todos os Eventos",
          icon: Calendar,
          path: "/events/list",
        },
        {
          title: "Lançar Custo no Evento",
          icon: TrendingDown,
          path: "/events/add-expense",
        },
        {
          title: "Fornecedores",
          icon: Truck,
          path: "/cadastros/suppliers",
        },
        {
          title: "Relatório de Eventos",
          icon: DollarSign,
          path: "/events/report",
        },
      ],
    };

    // Insert after Dashboard (index 1)
    items.splice(1, 0, eventProducersMenu);
  }

  // If company type is IT companies, inject "Gestão de TI" menu after Dashboard
  if (companyType === CompanyType.IT_COMPANIES) {
    const itCompaniesMenu: NavigationItem = {
      title: "💻 Gestão de TI",
      icon: Laptop,
      subItems: [
        {
          title: "Dashboard de TI",
          icon: BarChart3,
          path: "/it-companies/dashboard",
        },
        {
          title: "Projetos",
          icon: FolderKanban,
          path: "/it-companies/projects",
        },
        {
          title: "Contratos SLA",
          icon: FileText,
          path: "/it-companies/contracts",
        },
        {
          title: "Tickets",
          icon: ClipboardList,
          path: "/it-companies/tickets",
        },
        {
          title: "Relatório de SLA",
          icon: TrendingUp,
          path: "/it-companies/sla-report",
        },
      ],
    };

    // Insert after Dashboard (index 1)
    items.splice(1, 0, itCompaniesMenu);
  }

  // If company type is photographers/videographers, inject "Gestão de Projetos" menu after Dashboard
  if (companyType === CompanyType.PHOTOGRAPHERS_VIDEOGRAPHERS) {
    const photographersMenu: NavigationItem = {
      title: "📸 Gestão de Projetos",
      icon: Camera,
      subItems: [
        {
          title: "Dashboard de Projetos",
          icon: BarChart3,
          path: "/photographers/dashboard",
        },
        {
          title: "Todos os Projetos",
          icon: Briefcase,
          path: "/photographers/projects",
        },
        {
          title: "Lançar Custo no Projeto",
          icon: TrendingDown,
          path: "/photographers/add-expense",
        },
        {
          title: "Eventos",
          icon: Calendar,
          path: "/photographers/events",
        },
        {
          title: "Relatório de Lucratividade",
          icon: DollarSign,
          path: "/photographers/profitability",
        },
      ],
    };

    // Insert after Dashboard (index 1)
    items.splice(1, 0, photographersMenu);
  }

  // If company type is education professionals, inject "Gestão Educacional" menu after Dashboard
  if (companyType === CompanyType.EDUCATION_PROFESSIONALS) {
    const educationMenu: NavigationItem = {
      title: "📚 Gestão Educacional",
      icon: GraduationCap,
      subItems: [
        {
          title: "Dashboard Educacional",
          icon: BarChart3,
          path: "/education/dashboard",
        },
        {
          title: "Cursos",
          icon: FolderKanban,
          path: "/education/courses",
        },
        {
          title: "Alunos",
          icon: Users,
          path: "/cadastros/clients",
        },
        {
          title: "Vendas",
          icon: ShoppingCart,
          path: "/education/sales",
        },
        {
          title: "Relatório de Receitas",
          icon: DollarSign,
          path: "/education/revenue",
        },
      ],
    };

    // Insert after Dashboard (index 1)
    items.splice(1, 0, educationMenu);
  }

  // If company type is pilates/yoga studios, inject "Gestão do Estúdio" menu after Dashboard
  if (companyType === CompanyType.PILATES_YOGA_STUDIOS) {
    const pilatesYogaMenu: NavigationItem = {
      title: "🧘 Gestão do Estúdio",
      icon: Activity,
      subItems: [
        {
          title: "Dashboard do Estúdio",
          icon: BarChart3,
          path: "/pilates-yoga/dashboard",
        },
        {
          title: "Alunos",
          icon: Users,
          path: "/cadastros/clients",
        },
        {
          title: "Mensalidades",
          icon: CreditCard,
          path: "/pilates-yoga/subscriptions",
        },
        {
          title: "Aulas",
          icon: Calendar,
          path: "/pilates-yoga/classes",
        },
        {
          title: "Relatório Financeiro",
          icon: DollarSign,
          path: "/pilates-yoga/financial",
        },
      ],
    };

    // Insert after Dashboard (index 1)
    items.splice(1, 0, pilatesYogaMenu);
  }

  // If company type is veterinary clinics, inject "Gestão Veterinária" menu after Dashboard
  if (companyType === CompanyType.VETERINARY_CLINICS) {
    const veterinaryMenu: NavigationItem = {
      title: "🐾 Gestão Veterinária",
      icon: PawPrint,
      subItems: [
        {
          title: "Dashboard Veterinário",
          icon: BarChart3,
          path: "/veterinary/dashboard",
        },
        {
          title: "Pacientes",
          icon: Users,
          path: "/cadastros/clients",
        },
        {
          title: "Consultas",
          icon: Calendar,
          path: "/veterinary/consultations",
        },
        {
          title: "Procedimentos",
          icon: ClipboardList,
          path: "/veterinary/procedures",
        },
        {
          title: "Relatório de Receitas",
          icon: DollarSign,
          path: "/veterinary/revenue",
        },
      ],
    };

    // Insert after Dashboard (index 1)
    items.splice(1, 0, veterinaryMenu);
  }

  // If company type is beauty clinics, inject "Gestão de Estética" menu after Dashboard
  if (companyType === CompanyType.BEAUTY_CLINICS) {
    const beautyClinicsMenu: NavigationItem = {
      title: "✨ Gestão de Estética",
      icon: Sparkles,
      subItems: [
        {
          title: "Dashboard de Estética",
          icon: BarChart3,
          path: "/beauty-clinics/dashboard",
        },
        {
          title: "Pacientes",
          icon: Users,
          path: "/cadastros/clients",
        },
        {
          title: "Procedimentos",
          icon: ClipboardList,
          path: "/beauty-clinics/procedures",
        },
        {
          title: "Pacotes",
          icon: Package,
          path: "/beauty-clinics/packages",
        },
        {
          title: "Relatório de Receitas",
          icon: DollarSign,
          path: "/beauty-clinics/revenue",
        },
      ],
    };

    // Insert after Dashboard (index 1)
    items.splice(1, 0, beautyClinicsMenu);
  }

  // If company type is auto repair shops, inject "Gestão de Oficina" menu after Dashboard
  if (companyType === CompanyType.AUTO_REPAIR_SHOPS) {
    const autoRepairMenu: NavigationItem = {
      title: "🔧 Gestão de Oficina",
      icon: Wrench,
      subItems: [
        {
          title: "Dashboard da Oficina",
          icon: BarChart3,
          path: "/auto-repair/dashboard",
        },
        {
          title: "Ordens de Serviço",
          icon: ClipboardList,
          path: "/auto-repair/orders",
        },
        {
          title: "Veículos",
          icon: Car,
          path: "/auto-repair/vehicles",
        },
        {
          title: "Estoque",
          icon: Box,
          path: "/auto-repair/inventory",
        },
        {
          title: "Relatório de Serviços",
          icon: DollarSign,
          path: "/auto-repair/services-report",
        },
      ],
    };

    // Insert after Dashboard (index 1)
    items.splice(1, 0, autoRepairMenu);
  }

  // If company type is beauty salons, inject "Gestão do Salão" menu after Dashboard
  if (companyType === CompanyType.BEAUTY_SALONS) {
    const beautySalonsMenu: NavigationItem = {
      title: "💇 Gestão do Salão",
      icon: Scissors,
      subItems: [
        {
          title: "Dashboard do Salão",
          icon: BarChart3,
          path: "/beauty-salons/dashboard",
        },
        {
          title: "Agendamentos",
          icon: Calendar,
          path: "/calendar",
        },
        {
          title: "Serviços",
          icon: ClipboardList,
          path: "/beauty-salons/services",
        },
        {
          title: "Clientes",
          icon: Users,
          path: "/cadastros/clients",
        },
        {
          title: "Relatório de Receitas",
          icon: DollarSign,
          path: "/beauty-salons/revenue",
        },
      ],
    };

    // Insert after Dashboard (index 1)
    items.splice(1, 0, beautySalonsMenu);
  }

  return items;
}

// Default export for backward compatibility (when company type is not available)
export const navigationItems = baseNavigationItems;

